module.exports = __webpack_public_path__ + "img/storytelling@3x.c329e735.png";